import { TaskFilter } from '../views/task-filter';
import { TASK_FILTER_CONSTANTS, TASK_STATUS_UUID_MAP } from '../constants';
import { AFTER_7_DAYS, DATE_YMD, SUBTRACT_DAYS_FROM_TODAY, TODAY } from '../../utils';

export const GET_TASK_FILTER = (taskFilterConstant: string, accountId: number): TaskFilter => {
	let taskFilter = {} as TaskFilter;
	taskFilter.accountId = accountId;
	taskFilter.statusIds = [TASK_STATUS_UUID_MAP.IN_PROGRESS, TASK_STATUS_UUID_MAP.TO_DO];
	switch (taskFilterConstant) {
		case TASK_FILTER_CONSTANTS.DUE_TODAY:
			taskFilter.startDate = DATE_YMD(TODAY());
			taskFilter.endDate = DATE_YMD(TODAY());
			break;
		case TASK_FILTER_CONSTANTS.DUE_THIS_WEEK:
			taskFilter.startDate = DATE_YMD(TODAY());
			taskFilter.endDate = DATE_YMD(AFTER_7_DAYS());
			break;
		case TASK_FILTER_CONSTANTS.OVERDUE:
			const YESTERDAY = SUBTRACT_DAYS_FROM_TODAY(1);
			taskFilter.endDate = DATE_YMD(YESTERDAY);
			break;
		case TASK_FILTER_CONSTANTS.DONE:
			taskFilter.statusIds = [TASK_STATUS_UUID_MAP.DONE];
			break;
	}
	return taskFilter;
};
